import { render, staticRenderFns } from "./AiCrmMain.vue?vue&type=template&id=d2d202c2&scoped=true&"
import script from "./AiCrmMain.vue?vue&type=script&lang=js&"
export * from "./AiCrmMain.vue?vue&type=script&lang=js&"
import style0 from "./AiCrmMain.vue?vue&type=style&index=0&id=d2d202c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d202c2",
  null
  
)

export default component.exports